import { MenuItem } from './menu.model';

export const MENUFACT: MenuItem[] = [
    {
        id: 1,
        label: 'Menu',
        isTitle: true
    },
    {
        id: 2,
        label: 'Documentos',
        icon: 'bx bx-file',
        badge: {
            variant: 'info',
            text: '06',
        },
        subItems: [
        //   {
        //     id: 26,
        //     label: 'ICO Landing',
        //     link: '/crypto-ico-landing',
        //     parentId: 19
        // },
            {
                id: 3,
                label: 'Inicio',
                link: '/dashboard',
                parentId: 2
            },
            {
                id: 5,
                label: 'Retencionats',
                link: '/facturador/Retencionats',
                parentId: 2
            },
            {
              id: 6,
              label: 'Factura',
              link: '/facturador/Factura',
              parentId: 2
          },
          {
            id: 6,
            label: 'Nota Crédito',
            link: '/facturador/NotaCredito',
            parentId: 2
        },

          {
            id: 6,
            label: 'Guia Remisión',
            link: '/facturador/Guiaremision',
            parentId: 2
        },

          {
            id: 6,
            label: 'Liquidación',
            link: '/facturador/Liquidacion',
            parentId: 2
        },

        {
          id: 6,
          label: 'Retención',
          link: '/facturador/Retencion',
          parentId: 2
      },

        ]
    },
    {
      id: 2,
      label: 'Mantenimiento ',
      icon: 'bx bx-cog',
      badge: {
          variant: 'info',
          text: '02',
      },
      subItems: [

        {
          id: 6,
          label: 'Clientes',
          link: '/facturador/Cliente',
          parentId: 2
      },{
        id: 6,
        label: 'Producto',
        link: '/facturador/Producto',
        parentId: 2
    },{
      id: 6,
      label: 'Certificado',
      link: '/facturador/Certificado',
      parentId: 2
  }, {
    id: 7,
    label: 'Transportista',
    link: '/facturador/Transportista',
    parentId: 2
},{
  id: 8,
  label: 'Establecimiento',
  link: '/facturador/Establecimiento',
  parentId: 2
},{
  id: 8,
  label: 'Punto de Venta',
  link: '/facturador/PuntoVenta',
  parentId: 2
},{
  id: 8,
  label: 'Almacen',
  link: '/facturador/Almacen',
  parentId: 2
},{
  id: 9,
  label: 'Kardex',
  link: '/facturador/Kardex',
  parentId: 2
}
// ,{
//   id: 8,
//   label: 'Linea',
//   link: '/taller/Linea',
//   parentId: 2
// },{
//   id: 8,
//   label: 'Marca',
//   link: '/taller/Marca',
//   parentId: 2
// },{
//   id: 8,
//   label: 'Tecnico',
//   link: '/taller/Tecnico',
//   parentId: 2
// },{
//   id: 8,
//   label: 'Trabajo',
//   link: '/taller/Trabajo',
//   parentId: 2
// }





      ]
  },
  {
    id: 3,
    label: 'Procesos',
    icon: 'bx bxs-spreadsheet',
    badge: {
        variant: 'info',
        text: '01',
    },
    subItems: [
      {
          id: 4,
          label: 'Ajuste de stock',
          link: '/facturador/ajustestock',
          parentId: 2
      },
      {
        id: 4,
        label: 'Traslados',
        link: '/facturador/traslado',
        parentId: 2
    }
    ]
  },
  {
    id: 2,
    label: 'Reportes',
    icon: 'bx bxs-spreadsheet',
    badge: {
        variant: 'info',
        text: '01',
    },
    subItems: [
      {
          id: 4,
          label: 'Consulta de Documentos',
          link: '/consulta/consultaproceso',
          parentId: 2
      },
      {
        id: 4,
        label: 'Consulta de Hojas',
        link: '/taller/Reporte',
        parentId: 2
    },
    {
      id: 4,
      label: 'Consulta de ajustes',
      link: '/facturador/repoajuste',
      parentId: 2
  },
  {
    id: 4,
    label: 'Consulta de traslados',
    link: '/facturador/repotraslado',
    parentId: 2
}
    ]
},

];

